// PanelForm Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

class PanelForm extends Component {
  static get propTypes () {
    return {
      className: PropTypes.node,
      children: PropTypes.node
    }
  }

  static get defaultProps () {
    return {
      className: '',
      children: ''
    }
  }

  render () {
    const { children, className } = this.props

    return (
      <div className={`panel panel-form${className ? ' ' + className : ''}`}>
        {children}
      </div>
    )
  }
}

export default PanelForm
